import React from 'react';
import { Box, Text, Image, VStack, Grid, IconButton, Flex } from '@chakra-ui/react';
import Slider from 'react-slick';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Custom Arrow component
const Arrow = ({ className, style, onClick, isLeft }) => (
    <IconButton
        aria-label={isLeft ? "Previous Slide" : "Next Slide"}
        icon={isLeft ? <ChevronLeftIcon boxSize={6} /> : <ChevronRightIcon boxSize={6} />}
        onClick={onClick}
        position="absolute"
        top="50%"
        transform="translateY(-50%)"
        bg="white"
        boxShadow="lg"
        _hover={{ bg: "gray.300" }}
        style={style}
    />
);

const CardSlider = () => {
    // Slider settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <Arrow />,
        prevArrow: <Arrow isLeft />,
    };

    // Example data for cards
    const slides = [
        {
            teacher: {
                title: 'Best Teacher',
                name: 'Rubell',
                description: 'Physics Teacher',
                experience: '5 Years',
                imgSrc: 'https://imgs.search.brave.com/dsRxX9MNxgZMT4qHcqsl6IqedqonJa9yA2Ds1s3Brl8/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/cHJlbWl1bS1waG90/by9hdmF0YXItcmVz/b3VyY2luZy1jb21w/YW55XzEyNTQ5Njct/NjY1My5qcGc_c2l6/ZT02MjYmZXh0PWpw/Zw', // Replace with real image
                bg: 'green.400',
            },
            student: {
                title: 'Star Student',
                name: 'Tenesa',
                description: 'XII, A',
                grade: 'Grade A+',
                imgSrc: 'https://imgs.search.brave.com/wyUJktpoI3ttNlk1xaE9MtCnM93mkiqwXVEpx1gRn7s/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1wc2QvM2Qt/cmVuZGVyaW5nLWF2/YXRhcl8yMy0yMTUw/ODMzNTU0LmpwZz9z/aXplPTYyNiZleHQ9/anBn', // Replace with real image
                bg: 'blue.500',
            }
        },
        {
            teacher: {
                title: 'Top Teacher',
                name: 'Mr. John',
                description: 'Maths Teacher',
                experience: '8 Years',
                imgSrc: 'https://imgs.search.brave.com/fLBPY4YcRK7UpqhMI39BO80aVqw3O4XUI6kkebfxmlg/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/cHJlbWl1bS1wc2Qv/M2QtbmVyZHktc3R1/ZGVudF83MTYxMjgt/MTcwNS5qcGc_c2l6/ZT02MjYmZXh0PWpw/Zw', // Replace with real image
                bg: 'green.400',
            },
            student: {
                title: 'Star Student',
                name: 'Mia',
                description: 'XII, B',
                grade: 'Grade A',
                imgSrc: 'https://imgs.search.brave.com/lis0zGWDOUz9EwTQbAGAGXW-fsTjjwIbwosTwyrMRvw/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9jZG4z/ZC5pY29uc2NvdXQu/Y29tLzNkL3ByZW1p/dW0vdGh1bWIvc3R1/ZGVudC1hdmF0YXIt/M2QtaWNvbi1kb3du/bG9hZC1pbi1wbmct/YmxlbmQtZmJ4LWds/dGYtZmlsZS1mb3Jt/YXRzLS1naXJsLXlv/dW5nLXVzZXItcGFj/ay1hdmF0YXJzLWlj/b25zLTg2Mzk2NjIu/cG5nP2Y9d2VicA', // Replace with real image
                bg: 'blue.500',
            }
        },
    ];

    return (
        <Slider {...settings}>
            {slides.map((slide, index) => (
                <Grid
                    key={index}
                    templateColumns="repeat(2, 1fr)"
                    gap={6}
                    p={4}
                >
                    <Flex>
                        {/* Teacher Card */}
                        <Box p={4} bg={slide.teacher.bg} borderRadius="lg" color="white">
                            <VStack spacing={3} textAlign="center">
                                <Text fontSize="lg" fontWeight="bold">{slide.teacher.title}</Text>
                                <Text fontSize="3xl" fontWeight="bold">{slide.teacher.name}</Text>
                                <Text fontSize="md">{slide.teacher.description}</Text>
                                <Text fontSize="sm">Experience: {slide.teacher.experience}</Text>
                                <Image borderRadius="full" boxSize="120px" src={slide.teacher.imgSrc} alt={slide.teacher.name} />
                            </VStack>
                        </Box>
&nbsp;
&nbsp;
                        {/* Student Card */}
                        <Box p={4} bg={slide.student.bg} borderRadius="lg" color="white">
                            <VStack spacing={3} textAlign="center">
                                <Text fontSize="lg" fontWeight="bold">{slide.student.title}</Text>
                                <Text fontSize="3xl" fontWeight="bold">{slide.student.name}</Text>
                                <Text fontSize="md">{slide.student.description}</Text>
                                <Text fontSize="sm">Grade: {slide.student.grade}</Text>
                                <Image borderRadius="full" boxSize="120px" src={slide.student.imgSrc} alt={slide.student.name} />
                            </VStack>
                        </Box>
                    </Flex>
                </Grid>
            ))}
        </Slider>
    );
};

export default CardSlider;
